import { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { SolidColorType } from 'common/types/color-type'
import HeadingWithSpan from './HeadingWithSpan'

export const subtitleSizeClassNames = {
  default: 'fs-fluid-18-24 mt-lg-3 mt-1',
  large: 'mt-lg-3 mt-2 fs-fluid-24-32',
}

type HeadingAndTextType = {
  title: ReactNode
  subtitle?: ReactNode
  subtitleSize?: keyof typeof subtitleSizeClassNames
  condensed?: boolean
  color?: SolidColorType
  headingSize?: 1 | 2 | 3 | 4 | 5 | 6
  className?: string
  classesForTitle?: string
  classesForSubTitle?: string
  colSize?: 5 | 6 | 8 | 9 | 12
  centeredClasses?: string
}

const HeadingAndText: FC<HeadingAndTextType> = ({
  centeredClasses = 'text-center',
  children,
  className = '',
  classesForSubTitle = '',
  classesForTitle = '',
  colSize = 12,
  color = '',
  condensed,
  headingSize = 2,
  subtitle,
  subtitleSize = 'default',
  title,
}) => {
  return (
    <div className={className}>
      <HeadingWithSpan
        size={headingSize}
        className={classNames(
          `h${headingSize} fw-semibold`,
          classesForTitle,
          centeredClasses,
          'mb-lg-1 mb-0',
        )}
      >
        {title}
      </HeadingWithSpan>

      {subtitle ? (
        <div className={`col-lg-${colSize} mx-auto`}>
          <p
            dangerouslySetInnerHTML={{ __html: `${subtitle}` }}
            className={classNames(
              subtitleSizeClassNames[subtitleSize],
              'text-semibold',
              color ? `color-${color}` : 'text-muted',
              classesForSubTitle,
              centeredClasses,
            )}
          />
          {children}
        </div>
      ) : (
        children
      )}
    </div>
  )
}

export default HeadingAndText
